/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { withRouter } from 'react-router';

import '../assets/styles/class.scss';

const open = {
  '--src': `url(${
    require('assets/cc16a76982fd7aadd02413e753271c6b.png').default
  })`
};

const close = {
  '--src': `url(${
    require('assets/031659d0b68243202995fa0cab936b4a.png').default
  })`
};

class HeaderSkipWhite extends React.Component {
  render() {
    const { isMuted, setMuted, handlerEnd } = this.props;

    return (
      <div
        className={`header-skip-white ${css(styles.flex, styles.flex_layout)}`}
      >
        <div className={css(styles.flex_item)}>
          <a
            href="/"
            onClick={() => window.open('/', '_self')}
            style={{
              '--src': `url(${
                require('assets/eefb1f301146aef060ae5854c3daa078.svg').default
              })`
            }}
            className={`${css(styles.icon, styles.icon_layout)} close`}
          />
        </div>

        <div className={css(styles.flex_spacer)} />

        <h5
          className={`${css(
            styles.skip,
            styles.skip_layout
          )} cursor-pointer skip`}
          onClick={handlerEnd}
        >
          {'SKIP'}
        </h5>

        <div className={css(styles.flex_spacer1)} />

        <div
          className={`${css(styles.flex_item1)} cursor-pointer`}
          onClick={setMuted}
        >
          <div
            style={isMuted ? open : close}
            className={css(styles.image, styles.image_layout)}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(HeaderSkipWhite);

HeaderSkipWhite.inStorybook = true;

const styles = StyleSheet.create({
  flex: {
    display: 'flex'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 33
  },
  icon: {
    background: 'var(--src) center center / contain no-repeat',
    display: 'block'
  },
  icon_layout: {
    height: 25,
    width: 25,
    minWidth: 25,
    margin: '3.5px 4px'
  },
  flex_spacer: {
    flex: '1 1 982px'
  },
  skip: {
    display: 'flex',
    alignItems: 'center',
    font: '16px/1.75 "NotoSansCJKtc", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px'
  },
  skip_layout: {
    flex: '0 0 auto',
    margin: '2px 0px'
  },
  flex_spacer1: {
    flex: '0 0 auto',
    minWidth: 26
  },
  flex_item1: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 24
  },
  image: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image_layout: {
    height: 28,
    width: 24,
    minWidth: 24,
    margin: '2px 0px'
  }
});
